import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

import { ROUTES } from "~/router";
import BackButton from "~/screens/Auth/components/BackButton";
import { useVisitType } from "~/screens/Scheduling/PersonalInformation/hooks/use-visit-type";
import { PATIENT_STATUS, PatientStatus, VISIT_TYPES } from "~/services";
import { Button, Title, usePageTitle, useRedirect, useUsers } from "~/shared";
import { useAuthStore, useBookingFlowStore, usePatientStore } from "~/stores";
import { tw } from "~/utils";

const patientStatuses = [
  {
    id: PATIENT_STATUS.NEW,
    label: "I'm a new patient",
    description: "This is my first visit with Elektra Health",
  },
  {
    id: PATIENT_STATUS.RETURNING,
    label: "I'm a returning patient",
    description: "I've been seen by Elektra Health before",
  },
];

export const MeetClinician = () => {
  usePageTitle("Meet Clinician");

  const [selectedPatientStatus, setSelectedPatientStatus] =
    useState<PatientStatus | null>(null);

  const redirect = useRedirect();
  const setPatientType = usePatientStore((state) => state.setPatientType);
  const { setVisitType } = useVisitType();

  const clearBookingFlow = useBookingFlowStore((state) => state.clear);

  const isLoggedIn = useAuthStore((state) => state.isLoggedIn());
  const { getCurrentUser } = useUsers();
  const { data: currentUser } = getCurrentUser(isLoggedIn);

  const handleRedirect = () => {
    if (!selectedPatientStatus) {
      return;
    }
    setVisitType(
      selectedPatientStatus === PATIENT_STATUS.NEW
        ? VISIT_TYPES.INITIAL
        : VISIT_TYPES.FOLLOW_UP,
    );
    redirect(ROUTES.getStarted);
    setPatientType(selectedPatientStatus);
  };

  useEffect(() => {
    clearBookingFlow();
  }, []);

  useEffect(() => {
    if (currentUser && !currentUser.ehrId) {
      setVisitType(VISIT_TYPES.INITIAL);
      setPatientType(PATIENT_STATUS.NEW);
    }
  }, [currentUser]);

  if (currentUser && !currentUser.ehrId) {
    return <Navigate to={ROUTES.getStarted} replace />;
  }

  return (
    <div className="mx-auto space-y-2 md:max-w-lg">
      <BackButton variant="violet" to={ROUTES.hubBookVisit} />
      <div>
        <Title>Are you a new or returning patient?</Title>
      </div>

      <div className="mt-6 space-y-4">
        {patientStatuses.map((status) => (
          <button
            key={status.id}
            onClick={() => setSelectedPatientStatus(status.id)}
            className={tw(
              "w-full cursor-pointer rounded-lg border border-gray-200 bg-white p-3 text-left text-gray-700 transition-all duration-200 hover:border-violet-300 hover:bg-neutral-100/50",
              selectedPatientStatus === status.id &&
                "border-violet bg-violet/10 text-white",
            )}
          >
            <p className="text-midnight-indigo text-sm font-normal">
              {status.label}
            </p>
          </button>
        ))}
      </div>

      <div className="pt-4">
        <Button
          onClick={handleRedirect}
          disabled={!selectedPatientStatus}
          className="w-full"
        >
          Continue
        </Button>
      </div>
    </div>
  );
};
